import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";

export default class PagePrivacyDetail extends PageDetail {
	constructor() {
		super();
	}

	init($data) {
		super.init($data);

		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_DELETE))) {
			$(".jsBtnRemove").on("click", this.onDelete.bind(this))
		} else {
			$(".jsBtnRemove").remove();
		}
	}

	handleErrors(rs) {
		// Overridata per gestire in modo custom gli errori non legati ai singoli campi ma più generali (il messaggio compare in una modal)

		if (rs.StatusCode === 401) {
			return "Non hai l'autorizzazione per completare questa azione!"
		}
		if (rs.StatusCode === 412) {
			return "Non puoi cambiare lo stato in bozza perché questo elemento è utilizzato altrove!"
		}

		return PagePrivacyDetail.GENERIC_SAVE_ERROR; //500
	}

	getFieldErrorReturnedByServer(rs, code) {
		// Overridata per gestire in modo custom gli errori legati ai campi che arrivano dal server (il messaggio compare vicino al campo in questione)
		if (code === PagePrivacyDetail.ERROR_FIELD_CODE_NOT_UNIQUE) {
			return "Questo codice è già stato utilizzato (deve essere univoco per ogni voce)";
		} else {
			let error = null;
			error = TheApp.Res[TheApp.Locale]["ERROR." + code];
			if (!error)
				error = TheApp.Res[TheApp.Locale][code];
			if (error)
				return error
        }
		return code;
	}


	onDelete(dataIndex) {
		let modal = new ModalConfirm($("#template-modalConfirm"));
		modal.create(
			{
				title: "Conferma cancellazione",
				body: "Sei sicuro di voler rimuovere definitivamente questo elemento? Non puoi annullare questa azione.",
				yes: "SI",
				no: "NO",
				danger: true // viene il pulsante rosso, altrimenti blue
			}, this.onConfirmDelete.bind(this));
		modal.init();
	}

	onConfirmDelete(bConfirm) {
		if (bConfirm) {
			this.showPreloader(true);
			let rq = {
				Value: this.data.row.Uid
			}
			thatServiceManeger.standardCall(this.data.serviceDeleteRoute, rq, this.onDeleteServiceHandler.bind(this));
		}
	}

	onDeleteServiceHandler(rs) {
		this.showPreloader(false);
		//
		if (rs.Success) {
			let args = StateManager._splitUrl(document.location.href);
			let url = "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&__pi=" + this.data.page.PrevPageId
			document.location.href = TheApp.Env.BaseUrlNls + "privacy/" + url;

		} else {
			let error = null;
			if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
				error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
				if (rs.Errors[0].RefsUid.length > 0) {
					error = error.replace("{0}", rs.Errors[0].RefsUid);
				}
			}
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
			//
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "Si è verificato un'errore",
					body: error,
					close: "CLOSE",
					error: true
				});
			modal.init();
		}
	}

}

PagePrivacyDetail.ERROR_FIELD_CODE_NOT_UNIQUE = "UniqueFieldConstraintFailed";

